export const STAIRS_CATALOG = {
  stairs: {
    name: "Schody",
    items: {
      straight: {
        id: "stairs-straight",
        name: "Schody proste",
        description: "Schody jednobiegowe proste",
        category: "stairs",
        dimensions: { width: 100, height: 260, depth: 260 }, // height tutaj to długość w rzucie 2D
        rotation: 0,
        anchor: "center",
        collision: "box",
        placement: "free-standing",
        scalable: true,
        render2D: {
          type: "group",
          fill: "#ffffff",
          stroke: "#000000",
          strokeWidth: 2,
          elements: [
            // Outline (Prostokąt)
            { type: "rect", x: -50, y: -130, width: 100, height: 260 },
            // Stopnie (Linie poziome)
            { type: "path", path: "M-50,-110 L50,-110 M-50,-90 L50,-90 M-50,-70 L50,-70 M-50,-50 L50,-50 M-50,-30 L50,-30 M-50,-10 L50,-10 M-50,10 L50,10 M-50,30 L50,30 M-50,50 L50,50 M-50,70 L50,70 M-50,90 L50,90 M-50,110 L50,110", strokeWidth: 1, fill: "none" },
            // Linia biegu (Strzałka)
            { type: "path", path: "M0,130 L0,-120", strokeWidth: 1, fill: "none" },
            // Kropka startowa (na dole)
            { type: "circle", x: 0, y: 130, radius: 4, fill: "#000000", stroke: "#000000" },
            // Grot strzałki (na górze)
            { type: "path", path: "M-5,-115 L0,-130 L5,-115 Z", fill: "#000000", stroke: "#000000" }
          ]
        },
        thumbnail: "🪜",
        metadata: { type: "stairs", style: "straight" }
      },
      lShaped: {
        id: "stairs-l-shaped",
        name: "Schody łamane",
        description: "Schody zabiegowe (L-kształtne)",
        category: "stairs",
        dimensions: { width: 200, height: 200, depth: 200 },
        rotation: 0,
        anchor: "center",
        collision: "poly", // Dokładniejsza kolizja dla kształtu L
        placement: "free-standing",
        scalable: true,
        render2D: {
          type: "group",
          fill: "#ffffff",
          stroke: "#000000",
          strokeWidth: 2,
          elements: [
            // Obrys (Kształt L)
            // Górne ramię poziome: szer 200, gł 100
            // Prawe ramię pionowe: szer 100, gł 200
            // Współrzędne względem środka (0,0)
            { type: "path", path: "M-100,-100 L100,-100 L100,100 L0,100 L0,0 L-100,0 Z", strokeWidth: 2 },
            
            // Stopnie na górnym ramieniu (Pionowe linie)
            { type: "path", path: "M-80,-100 L-80,0 M-60,-100 L-60,0 M-40,-100 L-40,0 M-20,-100 L-20,0", strokeWidth: 1, fill: "none" },
            
            // Stopnie na prawym ramieniu (Poziome linie)
            { type: "path", path: "M0,20 L100,20 M0,40 L100,40 M0,60 L100,60 M0,80 L100,80", strokeWidth: 1, fill: "none" },
            
            // Podest/Zabieg (Linia przekątna w narożniku 0,0)
            { type: "path", path: "M0,0 L100,-100", strokeWidth: 1, fill: "none" },

            // Linia biegu (Łamana strzałka)
            { type: "path", path: "M-100,-50 L50,-50 L50,100", strokeWidth: 1, fill: "none" },
            
            // Kropka startowa (z lewej)
            { type: "circle", x: -100, y: -50, radius: 4, fill: "#000000", stroke: "#000000" },
            
            // Grot strzałki (na dole)
            { type: "path", path: "M45,85 L50,100 L55,85 Z", fill: "#000000", stroke: "#000000" }
          ]
        },
        thumbnail: "📐",
        metadata: { type: "stairs", style: "l-shape" }
      }
    }
  }
};

// Funkcje pomocnicze wymagane przez catalogManager i UI
export const getAllStairItems = () => {
  const allItems = [];
  Object.values(STAIRS_CATALOG).forEach(category => {
    Object.values(category.items).forEach(item => {
      allItems.push(item);
    });
  });
  return allItems;
};

export const getStairItemById = (id) => {
  const allItems = getAllStairItems();
  return allItems.find(item => item.id === id);
};